import { useCallback, useState, useEffect } from "react";
import { FontIcon, TooltipHost } from "@fluentui/react";
import CRMStatusTracker from "./CRMStatusTracker";
import CRMJournalItem from "./CRMJournalItem";
import useUser from "../../../hooks/useUser";

const CRMJournal = ({ items }) => {
  const sorted = items.sort((a, b) => a.journal.localeCompare(b.journal));
  const [active, setActive] = useState(sorted[0]);
  const [searchTerm, setSearchTerm] = useState("");
  const [filtered, setFiltered] = useState([]);
  const [searchOpen, setSearchOpen] = useState(true);
  const { user } = useUser();

  const handleActive = (item) => {
    setActive(item);
  };

  const handleSearchOpen = (e) => {
    e.preventDefault();
    setSearchOpen(!searchOpen);
  };

  const handleChange = (e) => {
    e.preventDefault();
    console.log(e.target.value);

    setSearchTerm(e.target.value);

    if (e.key === "Enter") {
      handleSearch(e);
      console.log("Enter pressed");
    }
  };

  const handleSearch = (e) => {
    e.preventDefault();
    console.log(searchTerm);
    filtered.length === 1 && setActive(filtered);
  };

  useEffect(() => {
    const results = sorted.filter((s, index) => {
      return s.journal.toLowerCase().includes(searchTerm.toLowerCase());
    });

    setFiltered(results);
  }, [searchTerm]);

  const CRMTitles = [
    "Librarians",
    "Email",
    "Demo",
    "Follow Up",
    "Negotiation",
    "Sale",
  ];
  const CRMStages = [
    "email",
    "demo",
    "followUp",
    "negotiation",
    "sale",
    "librarians",
  ];

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        width: "fit-content",
        margin: "auto",
      }}
    >
      <div className="crm-column">
        <div className="crm-title">
          Journals - All Leads
          <TooltipHost content="Open search box" delay={0} closeDelay={500}>
            <div className="crm-icons" onClick={handleSearchOpen}>
              <FontIcon
                iconName="Search"
                style={{ fontSize: 18, paddingTop: 10 }}
              />
            </div>
          </TooltipHost>
        </div>
        {!searchOpen && (
          <div className="crm-search-box">
            <div className="crm-journal-header">
              <div className="basic-input-wrapper" style={{ marginTop: -20 }}>
                <div className="basic-input-label" style={{ color: "white" }}>
                  Search
                </div>
                <input
                  type="text"
                  className="basic-input"
                  id="crm-input"
                  placeholder="Search"
                  name="Search"
                  onChange={handleChange}
                  value={searchTerm}
                />
              </div>
            </div>
            <div
              className="cj-row"
              style={{
                width: "fit-content",
                margin: "auto",
                paddingLeft: 30,
              }}
            >
              <div
                className="crm-search-btn"
                style={{
                  backgroundColor: "var(--green)",
                  color: "white",
                  width: 100,
                }}
                onClick={handleSearch}
              >
                Search
              </div>
              <div
                className="crm-search-btn"
                style={{
                  width: 100,
                  marginLeft: 15,
                }}
                onClick={(e) => {
                  e.preventDefault();
                  setSearchOpen(!searchOpen);
                  setFiltered(sorted);
                }}
              >
                Exit Search
              </div>
            </div>
          </div>
        )}
        <div className="crm-card-list">
          {filtered.map((j, index) => (
            <CRMJournalItem
              key={index}
              item={j}
              handleActive={handleActive}
              active={active}
              user={user}
            />
          ))}
        </div>
      </div>
      <div className="crm-column">
        <div className="crm-title">Status Tracker</div>
        <div className="crm-card-list">
          {CRMStages.map((stage, index) => (
            <CRMStatusTracker
              title={CRMTitles[index]}
              key={stage}
              active={active}
              stage={stage}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default CRMJournal;
